import React, { useEffect } from 'react';
import styled from 'styled-components';
import 'react-swipeable-list/dist/styles.css';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { message as toaster } from 'antd';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { Box, Image, Flex, Text } from 'atoms';
import downArrow from 'assets/down-arrow.svg';
import { InvoiceInfo, FilledDetails, InvoiceForm } from 'components/pages/collection';
// import { setIsInvoiceOpen } from 'store/invoiceSlice';
// import DelegateAvatar from 'assets/DelegateAvatar.svg';
import { AR } from 'utils/constants';
import rejectedIcon from 'assets/rejected-icon.svg';
import { theme } from 'styles/theme';

const Container = styled(Box)`
	width: 100%;
	padding: 10px;
	border-radius: 5px;
	background-color: white;
`;

// const StatusText = styled.span`
// 	font-size: 10px;
// 	font-weight: 600;
// 	color: ${(props) => (props.status === 'Pending' ? 'red' : 'green')};
// `;

// const Name = styled.span`
// 	font-size: 10px;
// `;
// const Time = styled.span`
// 	font-size: 10px;
// `;

function getRejectedPersonName(notifications) {
	if (notifications?.length === 0) {
		return '';
	}

	const { first_name = '', last_name = '' } = notifications?.[notifications.length - 1] || {};

	return `${first_name} ${last_name}`;
}

export function InvoiceCardSwipe({ data, showArrow = true, toggleState }) {
	const [isOpen, setIsOpen] = toggleState;
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	const { filteredInvoices = [] } = useSelector((state) => state.invoice);
	// const dispatch = useDispatch();
	const history = useHistory();

	function redirectToAmortization() {
		let salesmanId = '';

		if (me?.type === AR) {
			salesmanId = `&salesmanId=${selectedSalesMan?.id}`;
		}

		history.push({
			pathname: '/store',
			search: `?invoiceId=${data?.id}&storeId=${data?.store_id}${salesmanId}`,
		});
	}

	function handleCardClick() {
		const mine = filteredInvoices.filter((item) => item?.store_id === data?.store_id)?.length;

		if (mine > 1) {
			/**
			 * If more than one invoice available for amortization, then show the info, otherwise no needed
			 */
			toaster.info(`This store has multiple outstanding invoices,
			Redirecting you to amortization screen.`);

			setTimeout(() => {
				redirectToAmortization();
			}, 2000);
		} else {
			redirectToAmortization();
		}
	}

	/**
	 * Below function commented out, previously we have handled arrow click will open the form,
	 * now we are redirecting to amortization screen
	 */
	// function handleClick() {
	// 	dispatch(setIsInvoiceOpen(!isOpen));
	// 	// if (isFormOpen) {
	// 	// 	dispatch(setIsFormOpen(false));
	// 	// } else {
	// 	// 	dispatch(setIsFormOpen(true));
	// 	// }
	// 	setIsOpen(!isOpen);
	// 	handleCardClick();
	// }

	useEffect(
		() => () => {
			setIsOpen(false);
		},
		[setIsOpen]
	);

	return (
		<Container className="invoice-card-inner">
			{['RejectedBySegregator', 'RejectedByCashier']?.includes(
				data?.invoice_verification_status
			) && (
				<Flex my="10px" alignItems="center">
					<Image src={rejectedIcon} alt="rejectedIcon" height={18} width={18} />
					<Text
						fontWeight="600"
						fontSize="12px"
						lineHeight="16px"
						pl="0.5rem"
						color={theme.colors.TartOrange}
					>
						Rejected :
					</Text>
					<Text
						fontWeight="600"
						fontSize="12px"
						lineHeight="16px"
						pl="0.5rem"
						textTransform="capitalize"
					>
						{data?.invoice_verification_status?.replace('RejectedBy', '')} ~{' '}
						{getRejectedPersonName(data?.rejectNotification)}
					</Text>
				</Flex>
			)}
			<Flex
				flexDirection={data?.delegated_salesman_name ? 'column' : 'row'}
				justifyContent="space-between"
				alignItems={!data?.delegated_salesman_name && 'center'}
			>
				<InvoiceInfo data={data} />

				{showArrow && !data?.delegated_salesman_name && (
					<Flex
						p="0 1rem"
						flexDirection="column"
						justifyContent="space-between"
						alignItems="center"
						cursor="pointer"
						onClick={handleCardClick}
						className="card-arrow-btn"
					>
						<Image
							src={downArrow}
							alt="downArrow"
							height={12}
							width={18}
							className="rotate-90"
							// className={isOpen ? 'rotate' : 'reset-rotate'}
						/>
					</Flex>
				)}
			</Flex>
			{isOpen && showArrow ? (
				<Box pt="2rem" pb=".5rem" textAlign="center">
					<InvoiceForm data={data} onClose={() => setIsOpen(false)} />
				</Box>
			) : (
				showArrow && <FilledDetails data={data} />
			)}
			{/* {data?.delegated_salesman_name && (
				<Box mt="3">
					<Flex justifyContent="space-between">
						<div>
							<Image src={DelegateAvatar} alt="delegate" />
							<span> : </span>
							<Name> {data?.delegated_salesman_name}</Name>
							<Time> {`(${moment(data?.created_at).format('hh:mm')})`} </Time>
						</div>
						<div>
							<StatusText status={data?.delegated_status}>
								{data?.delegated_status}
							</StatusText>
						</div>
					</Flex>
				</Box>
			)} */}
		</Container>
	);
}

InvoiceCardSwipe.propTypes = {
	data: PropTypes.shape({
		verified_by_cashier_id: PropTypes.number,
		verified_by_segregator_id: PropTypes.number,
		status: PropTypes.string,
		billtype: PropTypes.string,
		delegated_salesman_name: PropTypes.string,
		delegated_salesman_first_name: PropTypes.string,
		delegated_salesman_last_name: PropTypes.string,
		delegated_status: PropTypes.string,
		created_at: PropTypes.any,
		id: PropTypes.number,
		store_id: PropTypes.number,
		invoice_verification_status: PropTypes.string,
		rejectNotification: PropTypes.array,
	}),
	showArrow: PropTypes.bool,
	toggleState: PropTypes.array,
};
